const defaultProperties =
{
    loading : false,
    setLoading : () => {}
};

export default defaultProperties;